import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { useSelector, connect } from 'react-redux';
import { isLoading } from '../../redux/actions/Loading';
import moment from 'moment';
import Select from '../utils/Select';
import DateField from '../utils/DateField';
import '../../sass/Reservacion.scss';




const validate = values => {
    const errors = {}

    if (values.LugarRecepcion === "Seleccione lugar..." || values.LugarRecepcion === undefined) {
        errors.LugarRecepcion = 'Campo requerido'
    }

    if (values.LugarDevolucion === "Seleccione lugar..." || values.LugarDevolucion === undefined) {
        errors.LugarDevolucion = 'Campo requerido'
    }

    if (!values.FechaRecepcion) {
        errors.FechaRecepcion = 'Seleccione una fecha y hora que no sea la actual'
    } else {
        let fechaPickup = new Date(values.FechaRecepcion);
        let fechaActual = new Date();
        let tiempo = (fechaPickup.getTime() - fechaActual.getTime()) / (1000 * 60 * 60);
        if (tiempo < 1) { errors.FechaRecepcion = 'Reserva con una hora de anticipación' }
    }

    if (!values.FechaDevolucion) {
        errors.FechaDevolucion = 'Seleccione una fecha y hora que no sea la actual'
    }

    let fechaRecepcion = new Date(values.FechaRecepcion);
    let fechaDevolucion = new Date(values.FechaDevolucion);

    if (fechaRecepcion.getTime() >= fechaDevolucion.getTime()) {
        errors.FechaRecepcion = 'Reserva con una hora de anticipación'
    }

    return errors
}

let FormReservacion = ({ handleSubmit, submitting, isLoading }) => {
    
    const sucursales = useSelector(state => state.sucursales);
    const catVehiculos = useSelector(state => state.categoriaVehiculos);
    const loading = useSelector(state => state.loading);

    useEffect(() => {
        (loading && sucursales.length > 0 && catVehiculos.length > 0) && isLoading(false);
    })

    let options = sucursales.map((sucursal) =>
        <option key={sucursal.Id} value={sucursal.Id}>{sucursal.Direccion}</option>
    )

    return (
        <div className="front-panel">
            <form onSubmit={handleSubmit}>
                <div className="card">
                    <div className="card-body">
                        <h2>HAZ TU RESERVA</h2>
                        <h3>RECEPCIÓN DEL VEHÍCULO</h3>
                        <Field label="* LUGAR" options={options} name="LugarRecepcion" component={Select} className="form-control" />
                        <Field label="* FECHA Y HORA" name="FechaRecepcion" component={DateField} type="text" placeholder="Ingrese fecha y hora de recepción"></Field>
                        <hr></hr>
                        <h3>DEVOLUCIÓN DEL VEHÍCULO</h3>
                        <Field label="* LUGAR" options={options} name="LugarDevolucion" component={Select} className="form-control" />
                        <Field label="* FECHA Y HORA" name="FechaDevolucion" component={DateField} type="text" placeholder="Ingrese fecha y hora de devolución" ></Field>
                        <div>
                            <small>* Llenar todos los campos obligatorios</small>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 box-buttons">
                                <button type="submit" className="btn btn-interamerican" disabled={submitting}>SIGUIENTE</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}


FormReservacion = reduxForm({
    form: 'FormReservacion',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate
})(FormReservacion);

const mapStateToProps = state => ({
    initialValues: {
        FechaRecepcion: moment(new Date()).format("MM/DD/YYYY hh:mm a"),
        FechaDevolucion: moment(new Date()).format("MM/DD/YYYY hh:mm a")
    }
})

const mapDispatchToProps = dispatch => ({
    isLoading: value => dispatch(isLoading(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormReservacion);